import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktTreatmentLineContainerModel } from '../../../../../../models';

@Injectable({
  providedIn: 'root',
})
export class DgMktTreatmentLineService extends BaseApiTemplateService<DgMktTreatmentLineContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'treatments-lines';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatments-lines';
    this.endpoint_path =
      Core2Config.DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatments-lines';
    this.httpClient = http;
  }
}
